import { useEffect, useState } from "react";

import {
  type AssertValidParams,
  FilterParams,
  type ParamsConstraint,
} from "./filter-params";
import type { FilterParamsHandle } from "./use-filter-params";

export const useDebouncedFilterParams = <T extends ParamsConstraint>(
  handle: FilterParamsHandle<T>,
  wait: number,
): [FilterParams<T>, boolean] => {
  const [debouncedState, setDebouncedState] = useState(() => ({
    params: new FilterParams<T>(
      handle.toObject() as Partial<T & AssertValidParams<T>>,
    ),
    paramsString: null as string | null,
  }));

  const currentString = handle.toString();
  const isDebouncing = debouncedState.paramsString !== currentString;

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedState({
        params: new FilterParams<T>(
          handle.toObject() as Partial<T & AssertValidParams<T>>,
        ),
        paramsString: currentString,
      });
    }, wait);

    return () => clearTimeout(timer);
  }, [currentString, handle, wait]);

  return [debouncedState.params, isDebouncing] as const;
};
